import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/yelloop-point.svg'


const _withScopeId = n => (_pushScopeId("data-v-26f30e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "p-4 gold-container"
}
const _hoisted_5 = { class: "row header-gold border-bottom-gold py-2 mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 d-flex align-items-end justify-content-lg-start justify-content-center mb-4 mb-lg-0 p-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "point"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold gold-text ps-3" }, "あなたのYELLポイント")
], -1))
const _hoisted_7 = { class: "col-lg-4 d-flex fw-bold justify-content-lg-end align-items-end justify-content-center p-0" }
const _hoisted_8 = { class: "number-point" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-25 ps-2" }, "pt", -1))
const _hoisted_11 = { class: "bg-white rounded-4 shadow p-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 text-green text-lg-start text-center fs-75" }, [
  /*#__PURE__*/_createElementVNode("p", null, "交換期限")
], -1))
const _hoisted_13 = { class: "col-lg-4 col-6 d-flex justify-content-center fs-75" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "col-lg-4 col-6 text-green text-end fs-75" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { class: "d-lg-flex justify-content-lg-between" }
const _hoisted_22 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_23 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_24 = { class: "d-flex justify-content-center mb-3" }

import Button from '@/components/button/index.vue'
import ModalPointHistory from './ModalPointHistory'
import { onMounted, ref, PropType, computed, ComputedRef } from 'vue'
import dayjs from 'dayjs'
import { numberWithCommas } from '@/constants/common.ts'
import { POINT_STORE, ROOT_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  tab_active: String,
  changeActiveTab: {
    type: Function as PropType<() => void>,
  },
},
  setup(__props) {

const props = __props

// import { translate } from '@/languages/i18n'

const store = useStore()
const today = new Date()
const today1 = dayjs().add(1, 'month')
const today2 = dayjs().add(2, 'month')

const dataPointAlumni = computed(() => store.getters[POINT_STORE.GETTERS.POINTS])
const loadingPoint = computed(() => store.getters[POINT_STORE.GETTERS.LOADING_POINTS])
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

onMounted(async () => {
  pointHistoryModal.value = new Modal(document.getElementById('pointHistoryModal'))
  try {
    store.dispatch(POINT_STORE.ACTIONS.SET_POINTS)
  } catch (error) {
    console.log(error)
  }
})

const changeCommunity = (value: string) => {
  props.changeActiveTab(value)
}
// 2022/10/12 VietNC point histories UAT#4607(Ph2-R20221021)
const pointHistoryModal = ref()
const getPointHistories = async () => {
  await store.dispatch(POINT_STORE.ACTIONS.SET_POINT_HISTORIES, { change: true, params: { page: 1 } })
  pointHistoryModal.value.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(loadingPoint))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(numberWithCommas)(Number(_unref(dataPointAlumni)?.total_points))), 1),
              _hoisted_9,
              _hoisted_10
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass([_unref(isMobile) ? 'mb-2' : 'mb-4', 'row fw-bold mx-lg-4 mx-0'])
            }, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(dayjs)(_unref(today)).format('YYYY年M月末')), 1),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(dayjs)(_unref(today1)).format('YYYY年M月末')), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(dayjs)(_unref(today2)).format('YYYY年M月以降')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(numberWithCommas)(Number(_unref(dataPointAlumni)?.end_of_this_month_points))) + "pt", 1),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(numberWithCommas)(Number(_unref(dataPointAlumni)?.end_of_next_month_points))) + "pt", 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(numberWithCommas)(Number(_unref(dataPointAlumni)?.other_points))) + "pt", 1)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(Button, {
                  title: 'ためる',
                  type: __props.tab_active === 'LeverageCommunityTab1' || __props.tab_active === 'InviteAlumniTab2' ? 'primary' : 'secondary',
                  size: 'small',
                  class: _normalizeClass([__props.tab_active === 'LeverageCommunityTab1' || __props.tab_active === 'InviteAlumniTab2' ? 'point-events' : '', 'fw-bold']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeCommunity('LeverageCommunityTab1')))
                }, null, 8, ["type", "class"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(Button, {
                  title: 'つかう',
                  type: __props.tab_active === 'MenuTab3' || __props.tab_active === 'ExchangeHistoryTab4' ? 'primary' : 'secondary',
                  size: 'small',
                  class: _normalizeClass('fw-bold'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeCommunity('MenuTab3')))
                }, null, 8, ["type"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(Button, {
                  title: '履歴',
                  type: 'secondary',
                  size: 'small',
                  class: _normalizeClass('fw-bold'),
                  onClick: getPointHistories
                })
              ])
            ])
          ])
        ])),
    _createVNode(_unref(ModalPointHistory))
  ], 64))
}
}

})